<app-modal
  [title]="titulo"
  [loading]="loading && !cliente"
  [showEditButton]="false"
  [editable]="editable"
  [editTooltip]="'Editar datos del cliente'"
  [showCloseButton]="true"
  [scrollable]="true"
  (onEditClick)="editableSwitcher()"
  (onCloseClick)="cerrar()"
>
  @if (cliente) {
    @if (editable) {
      <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 lg:gap-7">
        <div>
          <p class="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
            Tipo de persona
          </p>
          <p class="text-sm font-medium text-gray-800 dark:text-white/90">
            @if (cliente.persona.persona_tipo === 'J') {
              <app-badge
                [startIcon]="'apartment'"
              >
                Jurídica
              </app-badge>
            } @else {
              <app-badge
                [startIcon]="'person'"
                [color]="'light'"
              >
                Física
              </app-badge>
            }
          </p>
        </div>

        <div>
          <p class="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
            @if (cliente.persona.persona_tipo === 'F') {
              Nombre completo
            } @else {
              Razón social
            }
          </p>
          <p class="text-sm font-medium text-gray-800 dark:text-white/90">
            @if (cliente.persona.persona_tipo === 'F') {
              <!-- Los clientes nuevos no tienen apellido: el nombre completo va entero
                   en `nombre`. Concatenar a secas imprimía "Juan null". -->
              {{ nombreCompleto }}
            } @else {
              {{ cliente.persona.persona_tipo_detalle.nombre }}
            }
          </p>
        </div>

        <div>
          <p class="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
            Documento
          </p>
          <p class="text-sm font-medium text-gray-800 dark:text-white/90">
            {{ cliente.persona.documento_principal.numero }}
          </p>
        </div>

        <div>
          <p class="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
            País
          </p>
          <p class="text-sm font-medium text-gray-800 dark:text-white/90">
            {{ paisNombre }}
          </p>
        </div>

        <div>
          <p class="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
            Tipo de cliente
          </p>
          <p class="text-sm font-medium text-gray-800 dark:text-white/90">
            @if (cliente.tipo_cliente) {
              <app-badge
                [startIcon]="'label'"
                [color]="cliente.tipo_cliente.activo ? 'primary' : 'light'"
              >
                {{ cliente.tipo_cliente.nombre }}
              </app-badge>
            } @else {
              <span class="text-gray-500 dark:text-gray-400">Sin tipo asignado</span>
            }
          </p>
        </div>

        @if (cliente.persona.persona_tipo === 'J') {
          @if (cliente.persona.persona_tipo_detalle.nombre_fantasia) {
            <div>
              <p class="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
                Nombre comercial
              </p>
              <p class="text-sm font-medium text-gray-800 dark:text-white/90">
                {{ cliente.persona.persona_tipo_detalle.nombre_fantasia }}
              </p>
            </div>
          }

          <div>
            <p class="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
              Fecha de constitución
            </p>
            <p class="text-sm font-medium text-gray-800 dark:text-white/90">
              {{ cliente.persona.persona_tipo_detalle.fecha_constitucion || 'Sin datos' }}
            </p>
          </div>
        }

        <!--
          Issue #24 (2026-09-15): sexo y fecha de nacimiento dejan de mostrarse en el
          detalle del cliente. El dato sigue guardado y sigue viajando en la API; el
          formulario de edición lo reenvía tal como vino, así que no se pierde.

        @if (cliente.persona.persona_tipo === 'F') {
          <div>
            <p class="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
              Sexo
            </p>
            <p class="text-sm font-medium text-gray-800 dark:text-white/90">
              @if (cliente.persona.persona_tipo_detalle.sexo === 'M') {
                <app-badge
                  [startIcon]="'male'"
                  [color]="'light'"
                >
                  Masculino
                </app-badge>
              } @else if (cliente.persona.persona_tipo_detalle.sexo === 'F') {
                <app-badge
                  [startIcon]="'female'"
                  [color]="'light'"
                >
                  Femenino
                </app-badge>
              } @else {
                Sin datos
              }
            </p>
          </div>

          <div>
            <p class="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
              Fecha de nacimiento
            </p>
            <p class="text-sm font-medium text-gray-800 dark:text-white/90">
              {{ cliente.persona.persona_tipo_detalle.fecha_nacimiento || 'Sin datos' }}
            </p>
          </div>
        }
        -->
      </div>
    } @else {
      <app-form [formGroup]="editForm">
        <div class="grid grid-cols-1 gap-3 md:grid-cols-2">
          <div>
            <app-label for="persona_tipo">
              Tipo de persona
            </app-label>
            <app-input-field id="persona_tipo" type="text" [value]="esFisica ? 'Física' : 'Jurídica'" disabled readonly />
            <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
              No se puede modificar después del alta.
            </p>
          </div>

          <div>
            <app-label for="nombre">
              @if (esFisica) { Nombre } @else { Razón social }
            </app-label>
            <app-input-field id="nombre" formControlName="nombre" />
          </div>

          <!--
            El alta ya no separa nombre y apellido. El campo se sigue mostrando para los
            clientes que lo tienen cargado de antes: si no, su apellido quedaría invisible
            acá y sin embargo visible en los listados, que leen nombre_generico.
          -->
          @if (esFisica && tieneApellido) {
            <div>
              <app-label for="apellido">
                Apellido
              </app-label>
              <app-input-field id="apellido" formControlName="apellido" />
            </div>
          }

          <div>
            <app-label for="per_documento_tipo_id">
              Tipo de documento
            </app-label>
            <app-select id="per_documento_tipo_id" formControlName="per_documento_tipo_id" placeholder="Seleccione un tipo" [options]="documentosTiposOptions" />
          </div>

          <div>
            <app-label for="numero">
              N° Documento
            </app-label>
            <app-input-field id="numero" formControlName="numero" />
          </div>

          <div>
            <app-label for="ubi_pais_id">
              Ubicación
            </app-label>
            <app-select id="ubi_pais_id" formControlName="ubi_pais_id" placeholder="Seleccione una ubicación" [options]="paisesOptions" />
          </div>

          <div>
            <app-label for="param_tipo_cliente_id">
              Tipo de cliente
            </app-label>
            <app-select id="param_tipo_cliente_id" formControlName="param_tipo_cliente_id" placeholder="Seleccione un tipo" [options]="tiposClientesOptions" />
            @if (tipoClienteCambio) {
              <p class="mt-1 text-xs text-warning-500">
                Cambia la tarifa de los próximos servicios. Se pedirá confirmación al guardar.
              </p>
            }
          </div>

          @if (!esFisica) {
            <div>
              <app-label for="nombre_fantasia">
                Nombre de fantasía
              </app-label>
              <app-input-field id="nombre_fantasia" formControlName="nombre_fantasia" />
            </div>

            <div>
              <app-label for="fecha_constitucion">
                Fecha de constitución
              </app-label>
              <app-input-field id="fecha_constitucion" formControlName="fecha_constitucion" type="date" />
            </div>
          }

          <!-- Issue #24: sexo y fecha de nacimiento salen del formulario. Para reponerlos, descomentar.
          @if (esFisica) {
            <div>
              <app-label for="sexo">
                Sexo
              </app-label>
              <app-select id="sexo" formControlName="sexo" placeholder="Seleccione el sexo de la persona" [options]="sexoOptions" />
            </div>

            <div>
              <app-label for="fecha_nacimiento">
                Fecha de nacimiento
              </app-label>
              <app-input-field id="fecha_nacimiento" formControlName="fecha_nacimiento" type="date" />
            </div>
          }
          -->
        </div>
      </app-form>

      <app-edition-buttons *hasPermission="'clientes:edit'"
        [valid]="editForm.valid"
        [process]="process"
        [editable]="editable"
        [hideEditButton]="true"
        (onEditClick)="editableSwitcher()"
        (onCancelClick)="cerrar()"
        (onUpdateClick)="updateCliente()"
      />
    }

    <!-- La facturación pasó a su propia línea en la ficha (2026-10-05)
     Se recrea al recargar el cliente: lee el dato de facturación solo al iniciar 
    @if (!loading) {
      <div class="mt-6">
        <app-datos-facturacion
          [datoFacturacion]="cliente.persona.dato_facturacion"
          [cliente]="cliente"
          [perPersonaId]="cliente.per_persona_id"
          [clienteId]="idCliente"
          (referesh)="cambio = true; getCliente()"
        />
      </div>
    }
    -->
  }
</app-modal>
